module.exports = __webpack_public_path__ + "img/product03.b2ef7c6d.png";